/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Ui_Filter_SinceInputs */

const en_ui_filter_since = /** @type {(inputs: Ui_Filter_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`since ${i?.date}`)
};

const de_ui_filter_since = /** @type {(inputs: Ui_Filter_SinceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`seit ${i?.date}`)
};

/**
* | output |
* | --- |
* | "since {date}" |
*
* @param {Ui_Filter_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_since = /** @type {((inputs: Ui_Filter_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_since(inputs)
	return de_ui_filter_since(inputs)
});